import type { SyntheticEvent } from 'react';

export const DEFAULT_PRODUCT_IMAGE = '/icontab.png';

export const getProductImageUrl = (image?: string | null): string => {
  const trimmed = image?.trim();
  return trimmed || DEFAULT_PRODUCT_IMAGE;
};

export const getProductImageList = (images?: string[] | null): string[] => {
  const valid = (images || [])
    .map((url) => url?.trim())
    .filter((url): url is string => Boolean(url));

  return valid.length > 0 ? valid : [DEFAULT_PRODUCT_IMAGE];
};

export const handleProductImageError = (
  event: SyntheticEvent<HTMLImageElement>
): void => {
  const target = event.currentTarget;

  if (target.src.includes('icontab.png')) {
    return;
  }

  target.onerror = null;
  target.src = DEFAULT_PRODUCT_IMAGE;
};
